/**
 * Round 10 F5 -- the module this bank has and this account does not.
 *
 * Distinct from `ModuleNotLicensed` on purpose. That one answers an
 * upgrade question and points at an account team; this one is an
 * access fact about one person, and sending a service owner to his
 * account team about a module his colleagues use every day sends him
 * to the wrong person entirely.
 *
 * It replaces what he actually got, which was silence and a console:
 * three Framework links in his masthead, a queue that opened, a CAP
 * page offering four actions he could not complete, and twenty-three
 * 403s he never saw.
 */
import { useTranslation } from "react-i18next";

export function ModuleNotYours({ module }: { module: string }) {
  const { t } = useTranslation();
  return (
    <div
      data-testid="module-not-yours"
      data-module={module}
      className="mx-auto max-w-lg px-6 py-16 text-center"
    >
      <h1 className="font-display text-xl text-slate-900">
        {t(`moduleAccess.${module}.heading`, {
          defaultValue: t("moduleAccess.generic.heading"),
        })}
      </h1>
      <p className="mt-2 text-sm text-slate-500">{t("moduleAccess.body")}</p>
    </div>
  );
}
